import * as Types from '../../../../gql/__generated/graphql.types';

import { AuthorFieldsFragment } from './blogPostAuthor.generated';
import { SeoMetaDataFragment } from '../../../common/gql/__generated/seoMetadata.generated';
import { AuthorFieldsFragmentDoc } from './blogPostAuthor.generated';
import { SeoMetaDataFragmentDoc } from '../../../common/gql/__generated/seoMetadata.generated';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type BlogPostFieldsFragment = (
  { __typename?: 'BlogPost' }
  & Pick<Types.BlogPost, 'slug' | 'category' | 'tags' | 'title' | 'subtitle' | 'publicationDate' | 'relatedProducts' | 'shopLinks' | 'displayMeetTheAuthorSection' | 'moreInformationTitle' | 'readyToShopProducts'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Types.Sys, 'id' | 'publishedAt'>
  ), author?: Types.Maybe<(
    { __typename?: 'BlogPostAuthor' }
    & AuthorFieldsFragment
  )>, blogContent?: Types.Maybe<(
    { __typename?: 'BlogPostBlogContent' }
    & Pick<Types.BlogPostBlogContent, 'json'>
    & { links: (
      { __typename?: 'BlogPostBlogContentLinks' }
      & { assets: (
        { __typename?: 'BlogPostBlogContentAssets' }
        & { block: Array<Types.Maybe<(
          { __typename: 'ContentfullAsset' }
          & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
          & { sys: (
            { __typename?: 'Sys' }
            & Pick<Types.Sys, 'id'>
          ) }
        )>> }
      ) }
    ) }
  )>, image?: Types.Maybe<(
    { __typename?: 'ContentfullAsset' }
    & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
  )>, mobileImage?: Types.Maybe<(
    { __typename?: 'ContentfullAsset' }
    & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
  )>, moreInformationContent?: Types.Maybe<(
    { __typename?: 'BlogPostMoreInformationContent' }
    & Pick<Types.BlogPostMoreInformationContent, 'json'>
    & { links: (
      { __typename?: 'BlogPostMoreInformationContentLinks' }
      & { assets: (
        { __typename?: 'BlogPostMoreInformationContentAssets' }
        & { block: Array<Types.Maybe<(
          { __typename: 'ContentfullAsset' }
          & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
          & { sys: (
            { __typename?: 'Sys' }
            & Pick<Types.Sys, 'id'>
          ) }
        )>> }
      ) }
    ) }
  )>, relatedBlogPostsCollection?: Types.Maybe<(
    { __typename?: 'BlogPostRelatedBlogPostsCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BlogPost' }
      & BlogPostsFieldsFragment
    )>> }
  )> }
);

export type BlogPostBySlugQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type BlogPostBySlugQuery = (
  { __typename?: 'Query' }
  & { blogPostCollection?: Types.Maybe<(
    { __typename?: 'BlogPostCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BlogPost' }
      & BlogPostFieldsFragment
    )>> }
  )> }
);

export type BlogPostsFieldsFragment = (
  { __typename?: 'BlogPost' }
  & Pick<Types.BlogPost, 'slug' | 'category' | 'tags' | 'title' | 'subtitle'>
  & { image?: Types.Maybe<(
    { __typename?: 'ContentfullAsset' }
    & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
  )>, mobileImage?: Types.Maybe<(
    { __typename?: 'ContentfullAsset' }
    & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
  )> }
);

export type BlogPostListQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.BlogPostFilter>;
}>;


export type BlogPostListQuery = (
  { __typename?: 'Query' }
  & { blogPostCollection?: Types.Maybe<(
    { __typename?: 'BlogPostCollection' }
    & Pick<Types.BlogPostCollection, 'total' | 'limit'>
    & { items: Array<Types.Maybe<(
      { __typename?: 'BlogPost' }
      & BlogPostsFieldsFragment
    )>> }
  )> }
);

export type BlogPostListByAuthorQueryVariables = Types.Exact<{
  authorSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BlogPostListByAuthorQuery = (
  { __typename?: 'Query' }
  & { blogPostCollection?: Types.Maybe<(
    { __typename?: 'BlogPostCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BlogPost' }
      & BlogPostsFieldsFragment
    )>> }
  )> }
);

export type BlogPostSeoQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BlogPostSeoQuery = (
  { __typename?: 'Query' }
  & { blogPostCollection?: Types.Maybe<(
    { __typename?: 'BlogPostCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BlogPost' }
      & { seo?: Types.Maybe<(
        { __typename?: 'SeoMetadata' }
        & SeoMetaDataFragment
      )>, image?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url'>
      )> }
    )>> }
  )> }
);

export type BlogPostSitemapQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type BlogPostSitemapQuery = (
  { __typename?: 'Query' }
  & { blogPostCollection?: Types.Maybe<(
    { __typename?: 'BlogPostCollection' }
    & Pick<Types.BlogPostCollection, 'total'>
    & { items: Array<Types.Maybe<(
      { __typename?: 'BlogPost' }
      & Pick<Types.BlogPost, 'slug'>
    )>> }
  )> }
);


export const BlogPostsFieldsFragmentDoc = `
    fragment blogPostsFields on BlogPost {
  slug
  category
  tags
  title
  subtitle
  image {
    url
    title
    width
    height
  }
  mobileImage {
    url
    title
    width
    height
  }
}
    `;
export const BlogPostFieldsFragmentDoc = `
    fragment blogPostFields on BlogPost {
  sys {
    id
    publishedAt
  }
  slug
  author {
    ...AuthorFields
  }
  blogContent {
    json
    links {
      assets {
        block {
          sys {
            id
          }
          url
          title
          width
          height
          __typename
        }
      }
    }
  }
  category
  tags
  title
  subtitle
  image {
    url
    title
    width
    height
  }
  mobileImage {
    url
    title
    width
    height
  }
  publicationDate
  relatedProducts
  shopLinks
  displayMeetTheAuthorSection
  moreInformationTitle
  moreInformationContent {
    json
    links {
      assets {
        block {
          sys {
            id
          }
          url
          title
          width
          height
          __typename
        }
      }
    }
  }
  relatedBlogPostsCollection(limit: 3) {
    items {
      ...blogPostsFields
    }
  }
  readyToShopProducts
}
    `;
export const BlogPostBySlugDocument = `
    query blogPostBySlug($slug: String, $preview: Boolean) {
  blogPostCollection(limit: 1, where: {slug: $slug}, preview: $preview) {
    items {
      ...blogPostFields
    }
  }
}
    ${BlogPostFieldsFragmentDoc}
${AuthorFieldsFragmentDoc}
${BlogPostsFieldsFragmentDoc}`;

export const useBlogPostBySlugQuery = <
      TData = BlogPostBySlugQuery,
      TError = unknown
    >(
      variables?: BlogPostBySlugQueryVariables,
      options?: Omit<UseQueryOptions<BlogPostBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BlogPostBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BlogPostBySlugQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['blogPostBySlug'] : ['blogPostBySlug', variables],
    queryFn: graphqlFetcher<BlogPostBySlugQuery, BlogPostBySlugQueryVariables>(BlogPostBySlugDocument, variables),
    ...options
  }
    )};

useBlogPostBySlugQuery.getKey = (variables?: BlogPostBySlugQueryVariables) => variables === undefined ? ['blogPostBySlug'] : ['blogPostBySlug', variables];


useBlogPostBySlugQuery.fetcher = (variables?: BlogPostBySlugQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BlogPostBySlugQuery, BlogPostBySlugQueryVariables>(BlogPostBySlugDocument, variables, options);

export const BlogPostListDocument = `
    query blogPostList($limit: Int, $skip: Int, $where: BlogPostFilter) {
  blogPostCollection(limit: $limit, skip: $skip, where: $where) {
    total
    limit
    items {
      ...blogPostsFields
    }
  }
}
    ${BlogPostsFieldsFragmentDoc}`;

export const useBlogPostListQuery = <
      TData = BlogPostListQuery,
      TError = unknown
    >(
      variables?: BlogPostListQueryVariables,
      options?: Omit<UseQueryOptions<BlogPostListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BlogPostListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BlogPostListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['blogPostList'] : ['blogPostList', variables],
    queryFn: graphqlFetcher<BlogPostListQuery, BlogPostListQueryVariables>(BlogPostListDocument, variables),
    ...options
  }
    )};

useBlogPostListQuery.getKey = (variables?: BlogPostListQueryVariables) => variables === undefined ? ['blogPostList'] : ['blogPostList', variables];


useBlogPostListQuery.fetcher = (variables?: BlogPostListQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BlogPostListQuery, BlogPostListQueryVariables>(BlogPostListDocument, variables, options);

export const BlogPostListByAuthorDocument = `
    query blogPostListByAuthor($authorSlug: String) {
  blogPostCollection(where: {author: {slug: $authorSlug}}) {
    items {
      ...blogPostsFields
    }
  }
}
    ${BlogPostsFieldsFragmentDoc}`;

export const useBlogPostListByAuthorQuery = <
      TData = BlogPostListByAuthorQuery,
      TError = unknown
    >(
      variables?: BlogPostListByAuthorQueryVariables,
      options?: Omit<UseQueryOptions<BlogPostListByAuthorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BlogPostListByAuthorQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BlogPostListByAuthorQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['blogPostListByAuthor'] : ['blogPostListByAuthor', variables],
    queryFn: graphqlFetcher<BlogPostListByAuthorQuery, BlogPostListByAuthorQueryVariables>(BlogPostListByAuthorDocument, variables),
    ...options
  }
    )};

useBlogPostListByAuthorQuery.getKey = (variables?: BlogPostListByAuthorQueryVariables) => variables === undefined ? ['blogPostListByAuthor'] : ['blogPostListByAuthor', variables];


useBlogPostListByAuthorQuery.fetcher = (variables?: BlogPostListByAuthorQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BlogPostListByAuthorQuery, BlogPostListByAuthorQueryVariables>(BlogPostListByAuthorDocument, variables, options);

export const BlogPostSeoDocument = `
    query blogPostSeo($slug: String) {
  blogPostCollection(where: {slug: $slug}) {
    items {
      seo {
        ...SeoMetaData
      }
      image {
        url
      }
    }
  }
}
    ${SeoMetaDataFragmentDoc}`;

export const useBlogPostSeoQuery = <
      TData = BlogPostSeoQuery,
      TError = unknown
    >(
      variables?: BlogPostSeoQueryVariables,
      options?: Omit<UseQueryOptions<BlogPostSeoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BlogPostSeoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BlogPostSeoQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['blogPostSeo'] : ['blogPostSeo', variables],
    queryFn: graphqlFetcher<BlogPostSeoQuery, BlogPostSeoQueryVariables>(BlogPostSeoDocument, variables),
    ...options
  }
    )};

useBlogPostSeoQuery.getKey = (variables?: BlogPostSeoQueryVariables) => variables === undefined ? ['blogPostSeo'] : ['blogPostSeo', variables];


useBlogPostSeoQuery.fetcher = (variables?: BlogPostSeoQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BlogPostSeoQuery, BlogPostSeoQueryVariables>(BlogPostSeoDocument, variables, options);

export const BlogPostSitemapDocument = `
    query blogPostSitemap($skip: Int, $limit: Int) {
  blogPostCollection(skip: $skip, limit: $limit) {
    total
    items {
      slug
    }
  }
}
    `;

export const useBlogPostSitemapQuery = <
      TData = BlogPostSitemapQuery,
      TError = unknown
    >(
      variables?: BlogPostSitemapQueryVariables,
      options?: Omit<UseQueryOptions<BlogPostSitemapQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BlogPostSitemapQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BlogPostSitemapQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['blogPostSitemap'] : ['blogPostSitemap', variables],
    queryFn: graphqlFetcher<BlogPostSitemapQuery, BlogPostSitemapQueryVariables>(BlogPostSitemapDocument, variables),
    ...options
  }
    )};

useBlogPostSitemapQuery.getKey = (variables?: BlogPostSitemapQueryVariables) => variables === undefined ? ['blogPostSitemap'] : ['blogPostSitemap', variables];


useBlogPostSitemapQuery.fetcher = (variables?: BlogPostSitemapQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BlogPostSitemapQuery, BlogPostSitemapQueryVariables>(BlogPostSitemapDocument, variables, options);
